module.exports = __webpack_public_path__ + "static/media/circle_02.c6d46b42.svg";